import { render, staticRenderFns } from "./OrderSidebar.vue?vue&type=template&id=270d1c1f&"
import script from "./OrderSidebar.vue?vue&type=script&lang=ts&"
export * from "./OrderSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports